import { connect } from "react-redux";
import "./StudentAttendanceContent.scss";
import axios from "axios";
import { url_231 } from "../../../../../../custom_utilities/api_services";
import images from "../../../../../../utilities/images/images";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

const StudentAttendanceContent = (props) => {
  let { rollNo, startLoading, finishLoading } = props;
  const history = useHistory();

  const getDefaultSevenDaysStart = () => {
    const defaultStart = new Date();
    defaultStart.setDate(defaultStart.getDate() - 6);
    return defaultStart;
  };

  const [startDate, setStartDate] = useState(getDefaultSevenDaysStart);
  const [endDate, setEndDate] = useState(new Date());

  const [state, setState] = useState({
    attendanceDetails: {},
  });
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    console.log(startDate.toLocaleDateString("en-GB"));
  }, [startDate]);

  useEffect(() => {
    const defaultStart = getDefaultSevenDaysStart();
    const defaultEnd = new Date();
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    getAttendanceDetails(defaultStart, defaultEnd);
  }, []);

  const getAttendanceDetails = async (
    selectedStartDate = startDate,
    selectedEndDate = endDate
  ) => {
    const data = {
      method_name: "attendance_report",
      s_roll_no: `${rollNo}`,

      start_date: `${selectedStartDate.toLocaleDateString("en-US")}`,
      // Keep both keys because some backend versions read end_data.
      end_date: `${selectedEndDate.toLocaleDateString("en-US")}`,
      end_data: `${selectedEndDate.toLocaleDateString("en-US")}`,
    };
    startLoading();
    setIsFetching(true);
    try {
      const response = await axios.post(url_231, data);
      console.log("--------", response.data);
      if (response.data.status === "success") {
        setState((prevState) => ({
          ...prevState,
          attendanceDetails: response.data,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
      finishLoading();
    }
  };
  return (
    <div className="attendance__content_wrapper">
      <div className="grey_box">
        <div className="attendance_header">
          <button
            className="attendance_back_btn"
            onClick={() => history.push("/parent-dashboard")}
          >
            <img src={images.m2_backBtn} alt="back" />
          </button>
          <h1>Attendance</h1>
        </div>

        <div className="range_div">
          <div className="left">
            <p>Data showing from</p>
            <p>Search by specific date</p>
          </div>
          <div className="right">
            <div className="date">
              <p>From</p>
              {/* <p>01 April 2023</p> */}
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </div>
            <div className="date">
              <p>To</p>
              {/* <p>01 April 2023</p> */}
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
              />
            </div>
            <button onClick={() => getAttendanceDetails()} disabled={isFetching}>
              {isFetching ? "Loading..." : "Continue"}
            </button>
          </div>
        </div>

        {isFetching ? (
          <div className="attendance_loader_wrapper">
            <div className="attendance_loader_spinner"></div>
            <p>Fetching attendance details...</p>
          </div>
        ) : (
          <>
            <h2>Overall attendance record</h2>

            <div className="record_cards_wrapper">
              <div className="record_card">
                <p>Total Classes</p>
                <p>{state.attendanceDetails?.total_working_days}</p>
              </div>
              <div className="record_card">
                <p>Absent</p>
                <p className="red">{state.attendanceDetails?.total_absent_days}</p>
              </div>
              <div className="record_card">
                <p>Present</p>
                <p className="green">
                  {state.attendanceDetails?.toal_present_days}
                </p>
              </div>
              <div className="record_card">
                <p>Mis punch</p>
                <p className="yellow">
                  {state.attendanceDetails?.total_miss_punch}
                </p>
              </div>
            </div>
            <h2>Attendance details</h2>
            <div className="details_div">
              <div className="heading">
                <span>Date</span>
                <span>In-Time</span>
                <span>Out-Time</span>
                <span>Status</span>
              </div>
              {state.attendanceDetails.data?.map((element) => {
                return (
                  <div className="details" key={element.datetime}>
                    <span>{element.datetime}</span>
                    <span>{element.in_punch_time}</span>
                    <span>{element.out_punch_time}</span>
                    <span>{element.presance_status}</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
        
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
  };
};

export default connect(mapStateToProps, null)(StudentAttendanceContent);
